import React, { useReducer } from 'react';

import axios from 'axios';

import GithubContext from './githubContext';
import GithubReducer from './githubReducer';

import {
  SEARCH_USERS,
  CLEAR_USERS,
  GET_USER,
  GET_REPOS,
  SET_LOADING,
  SET_ALERT,
  REMOVE_ALERT,
} from '../Types';

let githubclientId;
let githubclientSecret;

if(process.env.NODE_ENV !== 'production'){
  githubclientId =  process.env.REACT_APP_ID
  githubclientSecret = process.env.REACT_APP_GITHUB_CLIENT_SECRET
}
else{
  githubclientId = process.env.GITHUB_CLIENT_ID
  githubclientSecret = process.env.GITHUB_CLIENT_SECRET
}

const GithubState = (props) => {
  const initialState = {
    users: [],
    user: {},
    loading: false,
    alert: null,
    repos: [],
  };

  const [state, dispatch] = useReducer(GithubReducer, initialState);

  const setLoading = () => dispatch({ type: SET_LOADING });

  const searchUsers = async (text) => {
    setLoading();

    const res = await axios.get(
      `https://api.github.com/search/users?q=${text}&client_id=${githubclientId}&client_secret=${githubclientSecret}`
    );

    dispatch({ type: SEARCH_USERS, payload: res.data.items });
  };

  const getUser = async (username) => {
    setLoading();

    const res = await axios.get(
      `https://api.github.com/users/${username}?client_id=${githubclientId}&client_secret=${githubclientSecret}`
    );

    dispatch({
      type: GET_USER,
      payload: res.data,
    });
  };

  const getUserRepos = async (username) => {
    setLoading();

    const res = await axios.get(
      `https://api.github.com/users/${username}/repos?per_page=8&sort=created:asc&client_id=${ githubclientId}&client_secret=${githubclientSecret}`
    );

    dispatch({
      type: GET_REPOS,
      payload: res.data,
    });
  };

  const clearUsers = () => {
    dispatch({
      type: CLEAR_USERS,
    });
  };

  const setAlert = (msg, type) => {
    dispatch({
      type: SET_ALERT,
      payload: {
        msg: msg,
        type: type,
      },
    });
    setTimeout(
      () =>
        dispatch({
          type: REMOVE_ALERT,
        }),
      3000
    );
  };

  //GithubState.Provider

  return (
    <GithubContext.Provider
      value={{
        users: state.users,
        user: state.user,
        repos: state.repos,
        loading: state.loading,
        alert: state.alert,
        text: state.text,
        searchUsers,
        getUser,
        getUserRepos,
        setAlert,
        setLoading,
        clearUsers,
      }}
    >
      {props.children}
    </GithubContext.Provider>
  );
};

export default GithubState;
